export default "__VITE_ASSET__BdiyB6wm__"